import { DateRange } from './types';

/** Mirrors the server cap: upstream fetches every source in the range and runs synchronously. */
export const MAX_RANGE_DAYS = 31;

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const toIsoDate = (d: Date): string => d.toISOString().slice(0, 10);

/** `Monday` for `2026-09-14`: the full English weekday, computed in UTC so it never depends on the viewer's local time zone. */
export const weekdayName = (date: string): string => new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' }).format(new Date(`${date}T00:00:00Z`));

export const defaultRange = (today: Date): DateRange => {
  const to = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
  const from = new Date(to.getTime() - 6 * MS_PER_DAY);
  return { from: toIsoDate(from), to: toIsoDate(to) };
};

export const inclusiveDaySpan = (from: string, to: string): number => Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / MS_PER_DAY) + 1;

export const daysInRange = ({ from, to }: DateRange): string[] => {
  const days: string[] = [];
  for (let t = Date.parse(`${from}T00:00:00Z`); t <= Date.parse(`${to}T00:00:00Z`); t += MS_PER_DAY) days.push(toIsoDate(new Date(t)));
  return days;
};

export const validateRange = (from: string, to: string): string | null => {
  if (!ISO_DATE.test(from)) return 'from must be a date (YYYY-MM-DD)';
  if (!ISO_DATE.test(to)) return 'to must be a date (YYYY-MM-DD)';
  const span = inclusiveDaySpan(from, to);
  if (span < 1) return `to (${to}) is before from (${from})`;
  if (span > MAX_RANGE_DAYS) return `range spans ${span} days; the maximum is ${MAX_RANGE_DAYS}`;
  return null;
};
